export default __webpack_public_path__ + "static/media/sf8.937a3fe5.svg";